import React, {useEffect} from "react";

// Import Swiper React components
import {Swiper, SwiperSlide} from "swiper/react";

// import required modules
import {Autoplay, FreeMode, Navigation, Pagination} from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import HeroContent from "../HeroContent";
import {useLanguage} from "../../../hooks/LanguageContext";

const HeroSlider = ({ sliders, swiperRef, setIsBeginning, setIsEnd }) => {
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
    const {direction} = useLanguage();

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.changeLanguageDirection(direction)
        }
    }, [direction,swiperRef]);

    return (
        <Swiper
            onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => {
                setIsEnd(swiper.isEnd);
                setIsBeginning(swiper.isBeginning);
            }}
            onSwiper={(swiper) => swiper.update()}
            observer={true}
            observeParents={true}
            pagination={{
                el: ".custom-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    const bulletNumber = index + 1;
                    const formattedNumber =
                        bulletNumber < 10 ? `0${bulletNumber}` : bulletNumber;
                    return `<span class="${className}" data-number="${formattedNumber}"></span>`;
                },
            }}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }}
            loop={true}
            freeMode={true}
            modules={[Navigation, Pagination,Autoplay,FreeMode]}
            className='relative w-full h-full'>
            {sliders.map((slider) => (
                <SwiperSlide
                    className='w-full h-full bg-top bg-no-repeat bg-cover min-h-[320px] md:min-h-[400px]'
                    style={{ backgroundImage: `url(${baseUrl}/${slider.image} )` }}
                    key={slider.id}>
                    <HeroContent slider={slider}/>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default HeroSlider;